import type { SearchArgs } from "./hooks";

function bool(value: string | null, fallback: boolean): boolean {
  if (value === null) return fallback;
  return value === "true";
}

/** Parses a search URL into typed query args. Booleans are `true`/`false` strings. */
export function parseSearchParams(params: URLSearchParams): SearchArgs | null {
  const q = params.get("q");
  if (q === null || q.trim().length === 0) return null;
  const scope = params.get("scope");
  const folder = params.get("folder");
  const from = params.get("from");
  const to = params.get("to");
  const before = params.get("before");
  const after = params.get("after");
  return {
    q,
    limit: 50,
    sortOrder: "desc",
    ...(scope !== null ? { scope: scope as NonNullable<SearchArgs["scope"]> } : {}),
    ...(folder !== null ? { folder: folder as NonNullable<SearchArgs["folder"]> } : {}),
    ...(from !== null ? { from } : {}),
    ...(to !== null ? { to } : {}),
    ...(before !== null ? { before } : {}),
    ...(after !== null ? { after } : {}),
    ...(params.has("isUnread") ? { isUnread: bool(params.get("isUnread"), false) } : {}),
    ...(params.has("hasAttachment")
      ? { hasAttachment: bool(params.get("hasAttachment"), false) }
      : {}),
  };
}

/** Serializes search inputs into a query string (q omitted when empty). */
export function buildSearchQuery(args: {
  readonly q: string;
  readonly isUnread?: boolean;
  readonly hasAttachment?: boolean;
  readonly scope?: string;
}): string {
  const params = new URLSearchParams();
  if (args.q.trim().length > 0) params.set("q", args.q.trim());
  if (args.isUnread === true) params.set("isUnread", "true");
  if (args.hasAttachment === true) params.set("hasAttachment", "true");
  if (args.scope !== undefined && args.scope !== "all") params.set("scope", args.scope);
  return params.toString();
}
